module.exports = __webpack_public_path__ + "img/wancheng.ff2f20ee.png";